<div class="history-modal">
  <div class="history-modal__header">
    <h1 class="history-modal__title">{{ 'monitoring.history.modal.title' | translate }}</h1>
  </div>

  <div class="history-modal__info">
    <div class="history-modal__info-block">
      <div class="history-modal__info-label">
        {{ 'monitoring.history.modal.user' | translate }}
      </div>
      <span class="history-modal__info-value">{{ modalData.user?.fullName || '—' }}</span>
      <span class="history-modal__info-value">{{ modalData.user?.email || '-' }}</span>
    </div>

    <div class="history-modal__info-block">
      <div class="history-modal__info-label">
        {{ 'monitoring.history.modal.entityChangedDate' | translate }}
      </div>
      <span class="history-modal__info-value">{{
        modalData.entityChangedDate | date: 'dd.MM.yyyy' : 'UTC'
      }}</span>
      <span class="history-modal__info-value-time"
        >{{ modalData.entityChangedDate | date: 'HH:mm:ss' : 'UTC' }} (UTC)</span
      >
    </div>

    <div class="history-modal__info-block">
      <div class="history-modal__info-label">
        {{ 'monitoring.history.modal.action' | translate }}
      </div>
      <span class="history-modal__info-value">{{
        modalData.action ? (`monitoring.history.actions.${modalData.action}` | translate) : '—'
      }}</span>
    </div>

    <div class="history-modal__info-block">
      <div class="history-modal__info-label">
        {{ 'monitoring.history.modal.entityType' | translate }}
      </div>
      <span class="history-modal__info-value">{{ modalData.entityType || '—' }}</span>
    </div>
  </div>

  <div class="history-modal__subtitle">
    {{ 'monitoring.history.modal.details' | translate }}
  </div>

  <div
    class="history-modal__details"
    [class.history-modal__details-single]="modalData.entitySnapshot"
  >
    @if (modalData.entitySnapshot) {
      <div class="history-modal__details-block">
        <div class="history-modal__details-value">
          <pre class="history-modal__details-value-json">{{ modalData.entitySnapshot | json }}</pre>
        </div>
      </div>
    } @else {
      <div class="history-modal__details-block">
        <div class="history-modal__details-label">
          {{ 'monitoring.history.modal.old-value' | translate }}
        </div>
        <div class="history-modal__details-value">
          @for (changedField of modalData.fieldChanges; track changedField.fieldName) {
            <span class="history-modal__details-value-text">{{
              `"${changedField.fieldName}": "${changedField.oldValue}"`
            }}</span>
          }
        </div>
      </div>
      <div class="history-modal__details-block">
        <div class="history-modal__details-label">
          {{ 'monitoring.history.modal.new-value' | translate }}
        </div>
        <div class="history-modal__details-value">
          @for (changedField of modalData.fieldChanges; track changedField.fieldName) {
            <span class="history-modal__details-value-text">{{
              `"${changedField.fieldName}": "${changedField.newValue}"`
            }}</span>
          }
        </div>
      </div>
    }
  </div>
</div>
